export default "/images/instagram_footer_logo.png";